<div mat-dialog-content>
    <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10  registro-form mt-3">
            <h1>Confirma tu Token</h1>
            <p class="text-forget-pass">Ingrese el código de 4 dígitos que hemos enviado al número registrado.</p>
            <form [formGroup]="tokenForm" (ngSubmit)="goToDatosGenerales()">
                <div class="row">
                    <div class="col-lg-12">
                        <input class="inputs cuadro-token" id="in1" type="text" maxLength="1" size="1" formControlName="numero_1">
                        <input class="inputs cuadro-token" id="in2" type="text" maxLength="1" size="1" formControlName="numero_2">
                        <input class="inputs cuadro-token" id="in3" type="text" maxLength="1" size="1" formControlName="numero_3">
                        <input class="inputs cuadro-token" id="in4" type="text" maxLength="1" size="1" formControlName="numero_4">
                    </div>
                </div>
                <br>
                <p class="text-forget-pass mt-2">¿No recibiste el código? <strong (click)="reenviartoken()">Enviar nuevo código</strong> </p>
                <p class="text-forget-pass mt-2" style="text-align: center;" *ngIf="flagNewToken"><strong>*Se ha enviado un nuevo token*</strong> </p>
                <p class="text-forget-pass mt-2" style="text-align: center;color:#cb4154;" *ngIf="errorToken"><strong>{{errorMessage}}</strong> </p>
                <div class="center-responsive">
                    <button [disabled]="!tokenForm.valid" type="submit" class="btn round-button  btn-continuar-general">Continuar</button>
                </div>
            </form>
        </div>
        <div class="col-md-1"></div>
    </div>
</div>
